<template>
  <transition name="fade">
    <div class="col-12 px-0" v-if="!getResponseInfo.arrayResponses">
      <b-alert v-if="getResponseInfo.status == 'info'" variant="info" dismissible fade :show="dismissCountDown = 5" @dismissed="clearResponse(); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.key,getResponseInfo.key)}}</span>
      </b-alert>
      <b-alert v-if="getResponseInfo.status == 'success'" variant="success" dismissible fade :show="dismissCountDown = 5" @dismissed="clearResponse(); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.key,getResponseInfo.key)}}</span>
      </b-alert>
      <b-alert v-if="getResponseInfo.status == 'error'" variant="danger" dismissible fade :show="dismissCountDown = 5" @dismissed="clearResponse(); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.key,getResponseInfo.key)}}</span>
        <span v-if="getResponseInfo.errorValue">
          <b>
            {{ getResponseInfo.errorValue }}
          </b>
        </span>
      </b-alert>
      <b-alert v-if="getResponseInfo.status == 'warning'" variant="warning" dismissible fade :show="dismissCountDown = 5" @dismissed="clearResponse(); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.key,getResponseInfo.key)}}</span>
        <ul class="mb-0" v-if="getResponseInfo.warningData">
          <li v-for="warning in getResponseInfo.warningData" :key="warning"> {{t(warning, warning)}}</li>
        </ul>
      </b-alert>
    </div>
    <div class="col-12" v-else>
      <b-alert v-if="getResponseInfo.arrayResponses[responseFlag].status == 'info'" variant="info" dismissible :show="dismissCountDown = 5" fade @dismissed="clearResponseByKey(responseFlag); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.arrayResponses[responseFlag].key,getResponseInfo.arrayResponses[responseFlag].key)}}</span>
      </b-alert>
      <b-alert v-if="getResponseInfo.arrayResponses[responseFlag].status == 'success'" variant="success" dismissible :show="dismissCountDown = 5" fade @dismissed="clearResponseByKey(responseFlag); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.arrayResponses[responseFlag].key,getResponseInfo.arrayResponses[responseFlag].key)}}</span>
      </b-alert>
      <b-alert v-if="getResponseInfo.arrayResponses[responseFlag].status == 'error'" variant="danger" dismissible :show="dismissCountDown = 5" fade @dismissed="clearResponseByKey(responseFlag); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.arrayResponses[responseFlag].key,getResponseInfo.arrayResponses[responseFlag].key)}}</span>
      </b-alert>
      <b-alert v-if="getResponseInfo.arrayResponses[responseFlag].status == 'warning'" variant="warning" dismissible :show="dismissCountDown = 5" fade @dismissed="clearResponseByKey(responseFlag); dismissCountDown = 0" @dismiss-count-down="countDownChanged">
        <span>{{ t(getResponseInfo.arrayResponses[responseFlag].key,getResponseInfo.arrayResponses[responseFlag].key)}}</span>
      </b-alert>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResponseInfo',
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  props: [
    'responseFlag'
  ],
  computed: {
    ...mapGetters(['getResponseInfo'])
  },
  methods: {
    clearResponse() {
      this.$store.dispatch('alertClearResponse')
    },
    clearResponseByKey(key) {
      this.$store.dispatch('alertClearArrayResponses', key)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
